import { Link } from "react-router-dom";
import { ArrowRight, LayoutDashboard } from "lucide-react";
import { useTranslation } from "react-i18next";
import { WAITLIST_URL } from "./constants";

interface HomeClosingCtaProps {
  signedIn: boolean;
}

export default function HomeClosingCta({ signedIn }: HomeClosingCtaProps) {
  const { t } = useTranslation("pages");

  return (
    <section className="border-t border-gray-800 bg-gray-900/40 text-white">
      <div className="mx-auto max-w-3xl px-6 py-20 text-center lg:py-24">
        <h2 className="mb-4 text-4xl font-bold tracking-tight text-balance sm:text-5xl">
          {t("home.ctaHeadline")}
        </h2>
        {signedIn ? (
          <>
            <p className="mb-8 text-lg text-gray-400">{t("home.ctaWelcomeBack")}</p>
            <Link
              to="/dashboard"
              className="inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-gray-900 transition-colors hover:bg-gray-100"
            >
              <LayoutDashboard className="h-4 w-4" />
              {t("home.goToDashboard")}
            </Link>
          </>
        ) : (
          <>
            <p className="mb-1 text-lg text-gray-400">{t("home.ctaPrivateBeta")}</p>
            <p className="mb-8 text-sm text-gray-500">{t("home.ctaWaitlistCopy")}</p>
            <a
              href={WAITLIST_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
            >
              {t("home.joinWaitingList")}
              <ArrowRight className="h-4 w-4" />
            </a>
          </>
        )}
      </div>
    </section>
  );
}
